import { ExchangeReportProfileInboxRule } from '../../../microsoft/exchange/profile/exchange-report-profile-inbox-rule';

export class ExchangeReportProfileRules {
  forwardMailBoxes: string[];
  hasTransportRules: boolean;
  hasJournalRules: boolean;
  inboxRules: ExchangeReportProfileInboxRule[];
}
